import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import { LanguageProvider } from './contexts/LanguageContext.tsx';
import './index.css';

// Show errors on screen for debugging
const showError = (message: string) => {
  const root = document.getElementById('root');
  if (root) {
    root.innerHTML = `
      <div style="padding: 20px; background: #fee; color: #c00; font-family: monospace; white-space: pre-wrap; overflow: auto; height: 100vh;">
        <h2>Error Loading App</h2>
        <p>${message}</p>
        <p>User Agent: ${navigator.userAgent}</p>
      </div>
    `;
  }
};

// Error boundary for production
window.addEventListener('error', (event) => {
  console.error('Global error:', event.error);
  showError(`Error: ${event.error?.message || 'Unknown error'}\n\nStack: ${event.error?.stack || 'No stack trace'}`);
});

window.addEventListener('unhandledrejection', (event) => {
  console.error('Unhandled promise rejection:', event.reason);
  showError(`Promise rejection: ${event.reason}`);
});

try {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register('/sw.js').then((registration) => {
        console.log('Service Worker registered successfully');

        // Only update after initial registration is complete
        if (registration.active) {
          registration.update().catch(err => {
            console.log('Update check failed:', err);
          });
        }
      }).catch((error) => {
        console.error('Service worker registration failed:', error);
      });
    });
  }

  const rootElement = document.getElementById('root');
  if (!rootElement) {
    throw new Error('Root element not found');
  }

  // Hide loading indicator
  const loadingEl = document.getElementById('loading');
  if (loadingEl) {
    loadingEl.style.display = 'none';
  }

  createRoot(rootElement).render(
    <StrictMode>
      <LanguageProvider>
        <App />
      </LanguageProvider>
    </StrictMode>
  );
} catch (error) {
  console.error('Failed to initialize app:', error);
  showError(`Initialization error: ${error}`);
}
